export default "__VITE_ASSET__DvVxgeQ9__"